var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9849 5H24.4849C32.4849 5 37.4849 10 37.4849 18V28.125H21.8599C20.8349 28.125 19.9849 28.975 19.9849 30C19.9849 31.025 20.8349 31.875 21.8599 31.875H37.4849V42C37.4849 50 32.4849 55 24.4849 55H18.0099C10.0099 55 5.00986 50 5.00986 42V18C4.98486 10 9.98487 5 17.9849 5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5813 28.1245L43.4063 22.9496C43.0313 22.5746 42.8563 22.0996 42.8563 21.6246C42.8563 21.1496 43.0313 20.6496 43.4063 20.2996C44.1313 19.5746 45.3313 19.5746 46.0563 20.2996L54.4313 28.6745C55.1563 29.3995 55.1563 30.5995 54.4313 31.3245L46.0563 39.6995C45.3313 40.4245 44.1313 40.4245 43.4063 39.6995C42.6813 38.9745 42.6813 37.7745 43.4063 37.0495L48.5813 31.8745H37.4813V28.1245H48.5813Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.162b2890f88af23ea2cb86ec7b9f07ed.svg";
export { ForwardRef as ReactComponent };